import React from "react";

export const ReadingIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28px"
        height="28px"
        viewBox="0 0 32 32"
        version="1.1"
      >
        <g
          stroke="none"
          fillRule="evenodd"
          fill="none"
          fillOpacity="1"
          strokeWidth="1"
        >
          <g transform="translate(-101.000000, -55.000000)">
            <g transform="translate(101.000000, 55.000000)">
              <rect
                fill="#FF637A"
                opacity="0.149999991"
                x="0"
                y="0"
                width="32"
                height="32"
                rx="16"
              ></rect>
              <path
                fill="#FC4967"
                fillRule="nonzero"
                d="M8,10 L8,21.6923077 L14.1538462,21.6923077 C14.8317311,21.6923077 15.3846154,22.2451926 15.3846154,22.9230769 L16.6153846,22.9230769 C16.6153846,22.2451926 17.1682695,21.6923077 17.8461538,21.6923077 L24,21.6923077 L24,10 L17.8461538,10 C17.1129809,10 16.4519231,10.3245194 16,10.8365385 C15.5480769,10.3245194 14.8870191,10 14.1538462,10 L8,10 Z M9.23076923,11.2307692 L14.1538462,11.2307692 C14.8317311,11.2307692 15.3846154,11.7836542 15.3846154,12.4615385 L16.6153846,12.4615385 C16.6153846,11.7836542 17.1682695,11.2307692 17.8461538,11.2307692 L22.7692308,11.2307692 L22.7692308,20.4615385 L17.8461538,20.4615385 C17.1129809,20.4615385 16.4519231,20.7860578 16,21.2980769 C15.5480769,20.7860578 14.8870191,20.4615385 14.1538462,20.4615385 L9.23076923,20.4615385 L9.23076923,11.2307692 Z M15.3846154,13.6923077 L15.3846154,14.9230769 L16.6153846,14.9230769 L16.6153846,13.6923077 L15.3846154,13.6923077 Z M15.3846154,16.1538462 L15.3846154,17.3846154 L16.6153846,17.3846154 L16.6153846,16.1538462 L15.3846154,16.1538462 Z M15.3846154,18.6153846 L15.3846154,19.8461538 L16.6153846,19.8461538 L16.6153846,18.6153846 L15.3846154,18.6153846 Z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
